module.exports = __webpack_public_path__ + "static/media/box-l.6d91e6de.png";